// extracted by mini-css-extract-plugin
export default {"loginBlock":"ConfirmPasswordLayout_loginBlock__BsSzB","loginTitle":"ConfirmPasswordLayout_loginTitle__+0NsO","logo":"ConfirmPasswordLayout_logo__4qhwO"};